import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AdminLayout from "../components/AdminLayout";
import AddItemCategoryModal from '../components/AddItemCategoriaModal';
import { IconPlus } from "@tabler/icons-react";
import RequireGroup from '../components/RequireGroup';


const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

function EstoqueNovo() {
  const [formData, setFormData] = useState({
    origem: "",
    item: "",
    categoria: "",
    quantidade: "",
    tipo_item: "",
    observacao: "",
    responsavel: "",
    telefone: "",
    data_validade: "",
  });

  const [mensagem, setMensagem] = useState(null);
  const [erro, setErro] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [suggestedItems, setSuggestedItems] = useState([]);
  const [categories, setCategories] = useState([]);
  const [showCategoryModal, setShowCategoryModal] = useState(false);
  const navigate = useNavigate();

  // Função auxiliar para formatar o telefone, se necessário
  const formatTelefone = (value) => {
    value = value.replace(/\D/g, "");
    value = value.slice(0, 11);
    if (value.length <= 10) {
      return value
        .replace(/^(\d{2})(\d)/, "($1) $2")
        .replace(/(\d{4})(\d)/, "$1-$2");
    } else {
      return value
        .replace(/^(\d{2})(\d)/, "($1) $2")
        .replace(/(\d{5})(\d)/, "$1-$2");
    }
  };

  const handleCategoryAdded = (newCategory) => {
    setCategories([...categories, newCategory]);
    // Define o valor do select para o novo ID criado, se necessário
    setFormData({ ...formData, categoria: newCategory.nome });
  };

  // Atualiza o state conforme os inputs mudam
  const handleChange = (e) => {
    const { name, value } = e.target;
    let formattedValue = value;
    if (name === "telefone") {
      formattedValue = formatTelefone(value);
    } else if (name === "origem" || name === "item" || name === "responsavel" || name === "observacao") {
      formattedValue = value.toUpperCase();
    }
    setFormData({
      ...formData,
      [name]: formattedValue,
    });
  };

    useEffect(() => {
      const fetchCategories = async () => {
        try {
          const res = await fetch(`${API_BASE_URL}estoque/itemcategorias/`);
          if (res.ok) {
            const data = await res.json();
            setCategories(data);
          } else {
            console.error("Erro ao buscar categorias");
          }
        } catch (error) {
          console.error("Erro na requisição de categorias:", error);
        }
      };
      fetchCategories();
    }, [API_BASE_URL]);

  // Envio do formulário: primeiro tenta cadastrar (ou recuperar) o item, depois registra o movimento
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
  
    try {
      // 1. Tenta cadastrar o item (ou recuperá-lo, se já existir)
      const itemResponse = await fetch(`${API_BASE_URL}estoque/items/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          descricao: formData.item,
          tipo_item: formData.tipo_item,
          categoria: formData.categoria,
          ...(formData.data_validade ? { data_validade: formData.data_validade } : {}),
        }),
      });
  
      if (!itemResponse.ok) {
        throw new Error("Erro ao cadastrar o item");
      }
      const itemData = await itemResponse.json();
      const itemId = itemData.id;
  
      // 2. Registra o movimento de entrada
      const movimentoResponse = await fetch(`${API_BASE_URL}estoque/movimentos/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          origem: formData.origem,
          item: itemId,
          item_descricao: formData.item,
          categoria: formData.categoria,
          quantidade: formData.quantidade,
          tipo: "Entrada", // Registro de entrada
          tipo_item: formData.tipo_item,
          observacao: formData.observacao,
          responsavel: formData.responsavel,
          telefone: formData.telefone,
        }),
      });
  
      if (movimentoResponse.ok) {
        setMensagem("Entrada cadastrada com sucesso!");
        setErro(null);
        // Limpa os campos do formulário
        setFormData({
          origem: "",
          item: "",
          categoria: "",
          quantidade: "",
          tipo_item: "",
          observacao: "",
          responsavel: "",
          telefone: "",
          data_validade: "",
        });
        setTimeout(() => {
          setMensagem("");
          navigate("/estoque");
        }, 3000);
      } else {
        setErro("Falha ao cadastrar a entrada. Verifique os dados.");
      }
    } catch (error) {
      console.error("Erro ao enviar para API:", error);
      setErro("Ocorreu um erro ao enviar o formulário.");
    } finally {
      setIsSubmitting(false);
    }
  };

  // Auto-oculta as mensagens de sucesso/erro após 5 segundos
  useEffect(() => {
    if (mensagem || erro) {
      const timer = setTimeout(() => {
        setMensagem("");
        setErro("");
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [mensagem, erro]);

  useEffect(() => {
    const fetchItems = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}estoque/items/`);
        if (response.ok) {
          const data = await response.json();
          setSuggestedItems(data);
        } else {
          console.error('Falha ao buscar os itens cadastrados');
        }
      } catch (error) {
        console.error('Erro ao buscar os itens:', error);
      }
    };
    fetchItems();
  }, []);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}estoque/itemcategorias/`);
        if (response.ok) {
          const data = await response.json();
          setCategories(data);
        } else {
          console.error('Falha ao buscar as categorias');
        }
      } catch (error) {
        console.error('Erro ao buscar as categorias:', error);
      }
    };
    fetchCategories();
  }, []);

  return (
    <AdminLayout>
      <div className="container mt-4">
        <div className="col-12">
          <form className="card" onSubmit={handleSubmit}>
            <div className="card-body">
              <h3 className="card-title">Nova Entrada</h3>
  
              {mensagem && <div className="alert alert-success">{mensagem}</div>}
              {erro && <div className="alert alert-danger">{erro}</div>}
  
              <div className="row row-cards">
                <h4 className="mt-4">1. Informações do Item</h4>
                {/* Origem */}
                <div className="col-md-4">
                  <div className="mb-3">
                    <label className="form-label">Origem</label>
                    <input
                      type="text"
                      className="form-control"
                      name="origem"
                      placeholder="Informe a origem da doação"
                      onChange={handleChange}
                      value={formData.origem}
                    />
                  </div>
                </div>
  
                {/* Item (descrição) */}
                <div className="col-md-8">
                  <div className="mb-3">
                    <label className="form-label">Item</label>
                    <input
                      type="text"
                      className="form-control"
                      name="item"
                      list="datalistOptions"
                      placeholder="Nome do item com algumas caracteristicas"
                      onChange={handleChange}
                      value={formData.item}
                    />
                    <datalist id="datalistOptions">
                      {suggestedItems.map((item) => (
                        <option key={item.id} value={item.descricao.toUpperCase()}>
                          {item.descricao.toUpperCase()}
                        </option>
                      ))}
                    </datalist>
                  </div>
                </div>

                {/* Categoria */}
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">Categoria</label>
                    <select
                      className="form-select"
                      name="categoria"
                      onChange={handleChange}
                      value={formData.categoria}
                    >
                      <option value="">Selecione</option>
                      {categories.map((cat) => (
                      <option key={cat.id} value={cat.nome}>
                          {cat.nome.toUpperCase()}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <RequireGroup group={['estoque_admin', 'admin']}>
                {/* Adicionar Nova Categoria */}
                <div className="col-md-2">
                  <label className="form-label text-white">.</label>
                  <button type="button" className="btn btn-secondary mb-3" aria-label="Adicionar nova categoria" onClick={() => setShowCategoryModal(true)}>
                    <IconPlus size={20} />
                    </button>
                  </div>
                </RequireGroup>

                { /* Data de Validade */}
                <div className="col-md-2">
                  <div className="mb-3">
                    <label className="form-label">Data de Validade</label>
                    <input
                      type="date"
                      className="form-control"
                      name="data_validade"
                      onChange={handleChange}
                      value={formData.data_validade}
                    />
                  </div>
                </div>
  
                {/* Quantidade */}
                <div className="col-md-2">
                  <div className="mb-3">
                    <label className="form-label">Quantidade</label>
                    <input
                      type="number"
                      className="form-control"
                      name="quantidade"
                      onChange={handleChange}
                      value={formData.quantidade}
                    />
                  </div>
                </div>
  
                {/* Tipo (Select) */}
                <div className="col-md-2">
                  <div className="mb-3">
                    <label className="form-label">Tipo</label>
                    <select
                      className="form-select"
                      name="tipo_item"
                      onChange={handleChange}
                      value={formData.tipo_item}
                    >
                      <option value="">Selecione</option>
                      <option value="Unidade">Unidade</option>
                      <option value="Caixa">Caixa</option>
                    </select>
                  </div>
                </div>
  
                {/* Observação */}
                <div className="col-md-8">
                  <div className="mb-3">
                    <label className="form-label">Observação</label>
                    <input
                      type="text"
                      className="form-control"
                      name="observacao"
                      placeholder="Observação (Opcional)"
                      onChange={handleChange}
                      value={formData.observacao}
                    />
                  </div>
                </div>
  
                <h4 className="mt-4">2. Informações do Responsável pela Entrega</h4>
                {/* Nome do Responsável */}
                <div className="col-md-8">
                  <div className="mb-3">
                    <label className="form-label">Nome</label>
                    <input
                      type="text"
                      className="form-control"
                      name="responsavel"
                      placeholder="Informe o nome do responsavel pela entrega da doação"
                      onChange={handleChange}
                      value={formData.responsavel}
                    />
                  </div>
                </div>
  
                {/* Telefone do Responsável */}
                <div className="col-md-4">
                  <div className="mb-3">
                    <label className="form-label">Telefone</label>
                    <input
                      type="text"
                      className="form-control"
                      name="telefone"
                      placeholder="(00) 00000-0000"
                      onChange={handleChange}
                      value={formData.telefone}
                    />
                  </div>
                </div>
              </div>
            </div>
  
            {/* Botões de ação */}
            <div className="card-footer text-end">
              <button
                type="button"
                className="btn btn-secondary me-2"
                onClick={() =>
                  setFormData({
                    origem: "",
                    item: "",
                    categoria: "",
                    quantidade: "",
                    tipo_item: "",
                    observacao: "",
                    responsavel: "",
                    telefone: "",
                    data_validade: "",
                  })
                }
              >
                Cancelar
              </button>
              <button type="submit" className="btn btn-primary" disabled={isSubmitting}>
                {isSubmitting ? "Salvando..." : "Salvar"}
              </button>
            </div>
          </form>
        </div>
      </div>
      <AddItemCategoryModal
        show={showCategoryModal}
        handleClose={() => setShowCategoryModal(false)}
        onCategoryAdded={handleCategoryAdded}
        API_BASE_URL={API_BASE_URL}
      />
    </AdminLayout>               
  );
}

export default EstoqueNovo;